/** @return {number} */
export function toNumberCurrency(strCurrency) {
	if (strCurrency == null) return 0;

	const currencyRegex = /[0-9]*\.[0-9]+|[0-9]+/gi;
	const matches = strCurrency.match(currencyRegex);

	return matches?.length ? parseFloat(matches[0]) : 0;
}

/** @return {string} */
export function formatStorePrice(
	price,
	formattedLocale,
	currency,
	currencyOptions = {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}
) {
	/*
    sample expected data for currency
    const currency = {
        "currencyCode": "USD",
        "currencyPlacement": null || "before",
        "currencySymbol": "$"
    }*/
	const locale = formattedLocale.split('_')[0] + '-' + formattedLocale.split('_')[1];

	//format currency
	if (!currency.currencyPlacement || currency.currencyPlacement === 'before') {
		return currency.currencySymbol + price.toLocaleString(locale, currencyOptions);
	} else {
		return price.toLocaleString(locale, currencyOptions) + currency.currencySymbol;
	}
}
